import {useEffect, useState} from "react";


function getWindowSize() {
  const {innerWidth, innerHeight} = window;
  return {width: innerWidth, height: innerHeight};
}

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(1024);
  // const [windowSize, setWindowSize] = useState(getWindowSize());


  // useEffect(() => {
  //   const handleWindowResize = () => {
  //     setWindowSize(getWindowSize());
  //   }
  //   window.addEventListener('resize', handleWindowResize);
  //   return () => {
  //     window.removeEventListener('resize', handleWindowResize);
  //   };
  // }, []);

  const isTablet = windowSize < 1024;
  const isMobile = windowSize < 768;

  return {windowSize, isMobile, isTablet}

}
export default useWindowSize;
